export const RebalancingFrequency = {
  M1: 'M1',
  M3: 'M3',
  M6: 'M6',
  M12: 'M12',
} as const;
